import * as yup from 'yup';
import { validateFieldMessages, requiredFieldMessages } from './messages';

export const YUP_PHONE_SCHEMA = yup.string()
  .test({
    test: (value, ctx) => {
      const digits = value?.replace(/\D/g, '').length ?? 0;
      if (!digits || digits === 10) {
        return true;
      }
      return ctx.createError({ message: validateFieldMessages.phoneNumber });
    },
  });

export const YUP_EMAIL_SCHEMA = yup.string()
  .required(requiredFieldMessages.email)
  .email(validateFieldMessages.email);

export const YUP_FIRST_NAME_SCHEMA = yup.string()
  .required(requiredFieldMessages.firstName);

export const YUP_LAST_NAME_SCHEMA = yup.string()
  .required(requiredFieldMessages.lastName);

export const YUP_STREET_SCHEMA = yup.string()
  .required(requiredFieldMessages.street);

export const YUP_CITY_SCHEMA = yup.string()
  .required(requiredFieldMessages.city);

export const YUP_POSTAL_CODE_SCHEMA = yup.string()
  .required(requiredFieldMessages.postalCode);

export const YUP_PASSWORD_SCHEMA = yup.string().required(requiredFieldMessages.password);
